/**
 * Generated by orval v8.18.0 🍺
 * Do not edit manually.
 * LiftAI API
 * LiftAI elevator/lift asset-management REST API.
 * OpenAPI spec version: 1.0.0 (v1)
 */

/**
 * * `unresolved` - Nobody has said
 * * `not_performed` - The rest never happened
 */
export type ResolutionEnum = typeof ResolutionEnum[keyof typeof ResolutionEnum];


export const ResolutionEnum = {
  unresolved: 'unresolved',
  not_performed: 'not_performed',
} as const;
